import { DatePipe } from '@angular/common';
import { Allocation, AllocationSortInput, Maybe, NiveauDeRisque, SortEnumType } from '@lib/models/generated/graphql';

export abstract class AllocationColumn {
  public header: string;
  public withSort: boolean = false;
  public isRightAligned: boolean = false;

  constructor(header: string, withSort: boolean = false) {
    this.withSort = withSort;
    this.header = header;
  }
  public abstract getData(allocation: Allocation, datePipe?: DatePipe): Maybe<string> | undefined;
  public getSortCriteria(isAsc: boolean): AllocationSortInput | undefined {
    return undefined;
  }
}

export class IdColumn extends AllocationColumn {
  constructor() {
    super('Id', false);
  }
  public override getData(allocation: Allocation, datePipe?: DatePipe): Maybe<string> | undefined {
    return allocation.id?.split('_')[0];
  }
}

export class NameColumn extends AllocationColumn {
  constructor() {
    super("Nom de l'allocation", true);
  }
  public override getData(allocation: Allocation, datePipe?: DatePipe): Maybe<string> | undefined {
    return allocation.libelle;
  }

  public override getSortCriteria(isAsc: boolean): AllocationSortInput | undefined {
    return { libelle: isAsc ? SortEnumType.Asc : SortEnumType.Desc };
  }
}

export class RisqueColumn extends AllocationColumn {
  constructor() {
    super('Niveau de risque lié', false);
  }
  public override getData(allocation: Allocation, datePipe?: DatePipe): Maybe<string> | undefined {
    const niveauDeRisque = allocation.niveauDeRisque;

    switch (niveauDeRisque) {
      case NiveauDeRisque.Securise:
        return 'Sécurisé';
      case NiveauDeRisque.Dynamique:
        return 'Dynamique';
      case NiveauDeRisque.Prudent:
        return 'Prudent';
      case NiveauDeRisque.Equilibre:
        return 'Equilibre';
      case NiveauDeRisque.Offensif:
        return 'Offensif';
      default:
        return '-';
    }
  }
}

export class FileColumn extends AllocationColumn {
  constructor() {
    super('Fichier', false);
  }
  public override getData(allocation: Allocation, datePipe?: DatePipe): Maybe<string> | undefined {
    return allocation.storageFile?.fileName ?? '-';
  }
}

export class DateModificationColumn extends AllocationColumn {
  constructor() {
    super('Mise à jour', true);
  }
  public override getData(allocation: Allocation, datePipe?: DatePipe): Maybe<string> | undefined {
    return datePipe?.transform(allocation.dateModification, 'dd/MM/yyyy') ?? '-';
  }
}
